import React, { ReactNode } from 'react'
import styled from 'styled-components'

interface NotificationProps {
    title: string
    children?: ReactNode
}
export const Notification = ({ title, children }: NotificationProps): JSX.Element => {
    return (
        <StyledNotification className={'StyledNotification'}>
            <span className={'StyledNotification__Title'}>{title}</span>
            {children && (
                <>
                    <br />
                    {children}
                </>
            )}
        </StyledNotification>
    )
}

const StyledNotification = styled.span`
    display: inline-block;
    .StyledNotification {
        &__Title {
            font-size: 18px;
            color: ${({ theme }) => theme.white};
            font-family: ${({ theme }) => theme['font-bold']};
            line-height: 30px;
        }
    }
`
